import { BibQuestion } from './aud-bib-question.model';
import { GeoDsMeta } from './meta-data.model';
export class BibCategory extends GeoDsMeta{
  Designation: string;
  Percentage?: number;
  Score?: number;
  SortNr?: number;
  Kind?: string;
  MaxScore?: number;
  Questions: BibQuestion[];
  ParentId: string;
  constructor(data?) {
    super();
    if (data) {
      Object.assign(this, data);
      if (data?.Questions) {
        this.Questions = [];
        data.Questions.forEach((question) => {
          this.Questions.push(new BibQuestion(question));
        });
      }
    }
  }
}